<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section ref="dataComponentRef" :class="containerStyles">
    <div :class="textWrapperStyles">
      <header2
        :text="title"
        :isUmbraco="isUmbraco"
        :theme="themeType"
        classes="mb-5"
        v-if="title"
      />
      <rich-text
        v-if="text"
        :text="text"
        :isUmbraco="isUmbraco"
        :theme="themeType"
        classes="mb-8"
      />
    </div>
    <div :class="blockWrpperStyles">
      <number-item
        v-if="numberLists && type === 'Numbers'"
        v-for="(item, index) in numberListToArray"
        :key="index"
        :title="item.title"
        :content="item.content"
        :index="index"
        :isUmbraco="isUmbraco"
        :theme="themeType"
        :animateIn="animateIn"
      />
      <icon-item
        v-if="iconList"
        v-for="(item, index) in iconListToArray"
        :key="index"
        :icon="item.icon"
        :title="item.title"
        :content="item.content"
        :index="index"
        :isUmbraco="isUmbraco"
        :theme="themeType"
      ></icon-item>
    </div>
  </section>
</template>

<script lang="ts" setup>
import Header2 from "@components/Typography/Header2.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import { IDataProps } from "@/types/components/IDataComponentProps";
import { changeTheme, getThemeType } from "@/util/helper";
import NumberItem from "@atoms/DataItems/NumberItem.ce.vue";
import IconItem from "@atoms/DataItems/IconItem.ce.vue";
import { computed, toRefs, onMounted, onUnmounted, ref, Ref, watch } from "vue";
import { onIntersect } from "@/composables/onIntersect";

const props = withDefaults(defineProps<IDataProps>(), {
  isUmbraco: false,
  componentWidth: "lg",
});
const {
  theme,
  title,
  text,
  type,
  numberLists,
  iconList,
  isUmbraco,
  componentWidth,
} = toRefs(props);

console.log("title", props.text);
const numberListToArray = numberLists ? JSON.parse(numberLists.value) : [];
const iconListToArray = iconList ? JSON.parse(iconList.value) : [];
const animateIn = ref(false);

const dataComponentRef: Ref<HTMLDivElement | null> = ref(null);
const observer: Ref<IntersectionObserver | null> = ref(null);

const onEnter = () => {
  changeTheme(theme.value);
  animateIn.value = true;
};
const onExit = () => {};

onMounted(() => {
  if (dataComponentRef.value) {
    observer.value = onIntersect(dataComponentRef.value, onEnter, onExit, false, {
      threshold: thresholdSetting.value,
    });
  }
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

watch(theme, (value) => {
  if (!value) return;
  changeTheme(value);
});

const thresholdSetting = computed(() => {
  return dataComponentRef.value &&
    dataComponentRef.value?.offsetHeight <= window.innerHeight
    ? Number(0.6)
    : Number(0.25);
});

const themeType = computed(() => {
  if (!theme?.value) return "light";
  if (getThemeType(theme.value) === undefined) return "light";
  return getThemeType(theme.value);
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco.value ? `bg-${theme?.value}` : ``;
  return `${bgColor} sectionContainer lg:min-h-screen py-10 py-20 relative`;
});

const textWrapperStyles = computed(() => {
  switch (componentWidth?.value) {
    case "lg":
      return `flex flex-col justify-start col-start-2 col-span-12 lg:col-span-4 lg:col-start-2 lg:row-start-1`; // 2
    case "sm":
      return `flex flex-col justify-start col-start-2 col-span-12 md:col-start-5 md:col-span-6`;
  }
});

const blockWrpperStyles = computed(() => {
  switch (componentWidth?.value) {
    case "lg":
      return `relative flex flex-wrap  col-span-12 col-start-2 lg:col-span-8 lg:col-start-6 lg:row-start-1 overflow-hidden gap-x-5 lg:gap-x-10 content-start`;
    case "sm":
      return `relative flex flex-wrap  col-span-12 col-start-2 lg:col-span-6 lg:col-start-5 overflow-hidden gap-x-5 lg:gap-x-10 content-start`; // 6  6
  }
});
</script>
